// Un clip del Estudio es borrador vigente si lo generó como borrador, nadie le cambió el
// archivo desde entonces (Mejorar calidad, Editar con IA, etc. reemplazan `storagePath`) y
// no venció (ADR-2026-09-27-borrador-480p-y-pasar-a-1080p). Puro.
export interface BorradorDeClip {
  jobId: string;
  venceEl: string;
  segundos: number;
  /** El archivo con el que se entregó: si el clip ya apunta a otro, fue editado. */
  storagePath: string;
}

export interface ClipConBorrador {
  type: string;
  aiStatus?: string;
  storagePath?: string;
  aiBorrador?: BorradorDeClip;
}

export function clipEsBorradorVigente(clip: ClipConBorrador, ahora: Date = new Date()): boolean {
  const b = clip.aiBorrador;
  if (!b || clip.type !== 'ai-generated' || clip.aiStatus !== 'ready') return false;
  if (!clip.storagePath || clip.storagePath !== b.storagePath) return false;
  return new Date(b.venceEl).getTime() >= ahora.getTime();
}
